import { render, staticRenderFns } from "./RequestMessages.vue?vue&type=template&id=3cac9e20&"
import script from "./RequestMessages.vue?vue&type=script&lang=js&"
export * from "./RequestMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports